import React from "react";

import { noTransaction } from "../../assets/images";
import {
  UserActivityReferralsTable,
  type UserReferralItem,
} from "./userActivityReferralsTable";

const Referrals = ({ referrals }: { referrals?: UserReferralItem[] }) => {
  return (
    <div className="w-full">
      <UserActivityReferralsTable
        referrals={referrals ?? []}
        emptyImage={noTransaction}
      />
    </div>
  );
};

export default Referrals;
